const IconSoket = ({ className }: any) => (
  <svg className={className} width="48" height="20" viewBox="0 0 48 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.867188 19.2541V14.6271H12.4342V0.746094H35.5672V14.6271H47.1342V19.2541H0.867188Z" fill="black" />
  </svg>
);

export default IconSoket;
